<app-ag-modal-container (clickClose)="closeModal()">
  <div class="entities-advise-modal">
    <img src="../../../assets/images/Support icon.png" />
    <ng-container *ngIf="primary">
      <div class="paragraph">
        <span class="bold">{{
          "¿Has añadido todos los bancos donde tienes ingresos?" | translate
        }}</span>
        <span>{{
          "¡Asegúrate bien! Solo tendremos en cuenta los bancos agregados correctamente y no podrás incluir otros después."
            | translate
        }}</span>
      </div>
      <div class="buttons-container">
        <button class="secondary" (click)="addMoreEntities()">
          <span>{{ "Añadir más" | translate }}</span>
        </button>
        <button class="primary" (click)="finish()" [disabled]="isFinishing">
          <span>{{ "Continuar" | translate }}</span>
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="!primary">
      <div class="paragraph">
        <span class="bold">{{
          "¿Deseas continuar solo con los bancos que están completados?"
            | translate
        }}</span>
        <span>{{
          "Algunos bancos seleccionados presentan errores y serán descartados de la solicitud."
            | translate
        }}</span>
      </div>
      <div class="buttons-container secondary">
        <button class="secondary" (click)="finish()" [disabled]="isFinishing">
          <span>{{ "Omitir y continuar con la solicitud" | translate }}</span>
        </button>
        <button class="primary" (click)="closeModal()">
          <span>{{ "Revisar errores" | translate }}</span>
        </button>
      </div>
    </ng-container>
  </div>
</app-ag-modal-container>
